import {FETCH_CUSTOMER_EMAIL } from "../../actions/actionTypes";

const initialState = {  
    data:[],
    loading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {    
        case FETCH_CUSTOMER_EMAIL.REQUEST:
            return {...state,loading: true}
        case FETCH_CUSTOMER_EMAIL.FAILURE:
            return {...state, loading: false}
        case FETCH_CUSTOMER_EMAIL.SUCCESS:             
            return {...state, data: action.obj.data, loading: false}    
        default:
            return state
    }
}

export default reducer;